import test from "./permissions_test";
import prod from "./permissions_prod";

export default process.env.REACT_APP_STAGE === "prod" ? prod : test;
